import {ButtonPrimary} from '@homeaway/react-buttons';
import Modal from '@homeaway/react-modal';
import {SVGIcon} from '@homeaway/react-svg';
import {SUCCESS__16} from '@homeaway/svg-defs';
import {LoadingOverlay} from '@homeaway/react-loading-overlay';

import TestExposureOnce from '../../../abacus/test-exposure-once';
import React, {Component} from 'react';
import PreviewInviteModal from './preview-invite-modal';

import edap from '../edap';

import './accept-invite-modal.less';
import {HA_PULSE_INVITE_ACCEPT_MODAL_TEST} from '../../../abacus/experiments';

export const testExposureInviteModal = new TestExposureOnce(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);

class AcceptInviteModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: true // pop on creation
        };
    }

    componentDidMount = () => {
        const {byPass} = this.props;

        if (!byPass) {
            edap.validInviteModalPop(this.props.invitationId, this.props.boardId);
            this.getLoginUrl();
        }
    };

    handleClose = (closeType) => () => {
        edap.validInviteModalClose(this.props.invitationId, this.props.boardId, closeType);
        testExposureInviteModal.trigger(HA_PULSE_INVITE_ACCEPT_MODAL_TEST);
        this.setState({
            isOpen: false
        });
    };

    getLoginUrl = () => {
        const {loginFetchError, loginFetchLoading, fetchLogin, loginUrl, fullLocale, siteName} = this.props;
        if (fullLocale && siteName && !loginFetchError && !loginFetchLoading && !loginUrl) {
            fetchLogin(fullLocale, siteName);
        }
    };

    handleLoginEdap = () => {
        edap.validInviteModalLogin(this.props.invitationId, this.props.boardId);
    };

    handleLogin = () => {
        // replace the redirect URL from cas with the original /i/ URL
        if (this.props.loginUrl) {
            const regex = /tripboard(.*?)&kmsi=true/g;
            return this.props.loginUrl.replace(regex, `tripboard%252Fi%252F${this.props.invitationId}&kmsi=true`);
        }
        return '';
    };

    render() {
        const {
            addText,
            loginToText,
            loginFetchLoading,
            skipText,
            titleText,
            voteText,
            loginText,
            tripBoardName,
            noPropertiesText,
            propertiesText,
            unitsCount,
            stay,
            tripBoard,
            byPass
        } = this.props;

        if (byPass) {
            return null;
        }

        const loginUrl = this.handleLogin();

        return (
            <Modal id={'accept-invite-modal'} isOpen={this.state.isOpen} onClose={this.handleClose('close')}>
                <div className="accept-invite-modal">
                    <PreviewInviteModal {...{noPropertiesText, propertiesText, unitsCount, stay, tripBoard}} />
                    <div className="accept-invite-modal__header">
                        <div>
                            <div>{titleText}</div>
                            <h2>{tripBoardName}</h2>
                        </div>
                    </div>
                    <div className="accept-invite-modal__body">
                        <div className="accept-invite-modal__body-copy">
                            <div className="accept-invite-modal__login">{loginToText}</div>
                            <div className="accept-invite-modal__bullets">
                                <SVGIcon inline className="text-white" markup={SUCCESS__16} />
                                {addText}
                            </div>
                            <div className="accept-invite-modal__bullets">
                                <SVGIcon inline className="text-white" markup={SUCCESS__16} />
                                {voteText}
                            </div>

                            <ButtonPrimary
                                className="accept-invite-modal__btn"
                                label={loginText}
                                href={loginUrl}
                                onClick={this.handleLoginEdap}
                            >
                                <LoadingOverlay loading={loginFetchLoading} />
                            </ButtonPrimary>
                        </div>
                        <div className="accept-invite-modal__exit">
                            <button
                                className="accept-invite-modal__exit-button"
                                onClick={this.handleClose('skip')}
                                label={`${skipText}${' >'}`}
                            >{`${skipText}${' >'}`}</button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}

export default AcceptInviteModal;



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/components/accept-invite-modal.js